/**
 * File upload handlers for VehicleInformationStep
 */
import { getFileKeyFieldName, validateFileSize } from './VehicleInformationStep.helpers';

/**
 * Handle file select button click
 */
export const handleFileSelect = (fieldName, fileInputRef, disabled) => {
	if (disabled) return;
	fileInputRef.current?.click();
};

/**
 * Handle file change and upload
 */
export const handleFileChange = async (
	event,
	fieldName,
	disabled,
	dispatch,
	getSignedUrl,
	setFieldValue,
	setUploading,
	messageInstance
) => {
	if (disabled) return;

	const file = event.target.files?.[0];
	if (!file) return;

	// Validate file size
	if (!validateFileSize(file, messageInstance)) {
		return;
	}

	// Set uploading state
	setUploading((prev) => ({ ...prev, [fieldName]: true }));

	try {
		// Step 1: Get signed URL
		const signedUrlResponse = await dispatch(
			getSignedUrl({
				url_type: 'upload',
				data: {
					entity: 'vendor',
					keys: [file.name],
				},
			})
		);

		const fileData = signedUrlResponse?.data?.[0];
		if (!fileData?.url || !fileData?.filename) {
			throw new Error('Failed to get signed URL');
		}

		// Step 2: Upload file to S3
		await fetch(fileData.url, {
			method: 'PUT',
			body: file,
			headers: {
				'Content-Type': file.type,
			},
		});

		// Step 3: Store file key in formik
		const fileKeyField = getFileKeyFieldName(fieldName);

		setFieldValue(`${fieldName}_file`, file);
		setFieldValue(fileKeyField, fileData.filename);

		messageInstance.success('File uploaded successfully');
	} catch (error) {
		console.error('File upload error:', error);
		messageInstance.error('Failed to upload file');
	} finally {
		setUploading((prev) => ({ ...prev, [fieldName]: false }));
		// Reset file input
		if (event.target) {
			event.target.value = '';
		}
	}
};

/**
 * Handle file upload button click
 */
export const handleFileUpload = (fieldName, refMap, handleFileSelectFn) => {
	const fileInputRef = refMap[fieldName];
	if (fileInputRef) {
		handleFileSelectFn(fieldName, fileInputRef);
	}
};
